<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-card :header="headerTitle" :header-tag="headingSize" class="bg-primary-card" :class="{ 'shadow-none': !chartCardShadow }">
                    <div v-if="chartLoaded">
                        <div style="height: 530px;">
                            <IEcharts :option="line" class="overflow-auto"></IEcharts>
                        </div>
                    </div>

                    <div v-else>
                        <p class="mb-0">
                            <i class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i> {{$t('general.projects.progress.no_steps')}}
                        </p>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import IEcharts from 'vue-echarts-v3/src/full.js';
import 'echarts/lib/chart/line';

export default {
    name: 'line_chart',
    components: {
        IEcharts,
    },
    props: {
        headerTitle: {
            type: String,
            default: ''
        },
        headingSize: {
            type: String,
            default: 'h3'
        },
        chartSeries: {
            type: Array,
            required: true
        },
        lineData: {
            type: Array,
            required: true
        },
        chartLegend: {
            type: Array,
            default: function () {
                return [];
            }
        },
        chartLoaded: {
            type: Boolean,
            default: false
        },
        chartCardShadow: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            line: {
                tooltip: {},
                grid: {
                    height: 350,
                    top: 150,
                    bottom: -150,
                    right: '7%',
                },
                legend: {
                    orient: 'vertical',
                    data: this.chartLegend
                },
                xAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#000000',
                        }
                    },
                    data: this.lineData,
                },
                yAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#000000',
                        }
                    },
                    axisTick: {
                        show: true,
                        alignWithLabel: false,
                        interval: 25,
                        inside: false,
                        length: 5,
                    },
                    type: 'value',
                    splitNumber: 5,
                },
                series: []
            }
        }
    },
    watch: {
        chartSeries: {
            immediate: true, 
            deep: true,
            handler(newVal, oldVal) {
                this.line.series = newVal;
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/common/charts/line_chart.vue